export const getStatusSeverity = (
  status: string
): 'success' | 'info' | 'warning' | 'danger' => {
  switch (status) {
    case 'COMPLETED':
      return 'success';
    case 'PROCESSING':
      return 'warning';
    case 'FAILED':
      return 'danger';
    default:
      return 'info';
  }
};
